import { render, staticRenderFns } from "./AuditRating.vue?vue&type=template&id=47453910&"
import script from "./AuditRating.vue?vue&type=script&lang=js&"
export * from "./AuditRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports